// extracted by css-extract-rspack-plugin
export default {"additional-category":"additional-category-zmPpiB","additionalCategory":"additional-category-zmPpiB"};